import { useSyncExternalStore } from "react";
import { isPhoneViewport, parsePhoneOverride } from "@/domain/device";

const COARSE_POINTER = "(pointer: coarse)";

// Read ONCE at module load rather than per render: the override is a testing
// and misdetection escape hatch that should hold for the whole visit, and
// in-app navigation drops the query string from the URL almost immediately.
const PHONE_OVERRIDE =
  typeof window === "undefined" ? null : parsePhoneOverride(window.location.search);

function subscribe(callback: () => void) {
  const media = window.matchMedia(COARSE_POINTER);
  window.addEventListener("resize", callback);
  window.addEventListener("orientationchange", callback);
  // The pointer can change too -- a tablet gaining a mouse -- so watch it.
  media.addEventListener("change", callback);
  return () => {
    window.removeEventListener("resize", callback);
    window.removeEventListener("orientationchange", callback);
    media.removeEventListener("change", callback);
  };
}

function getSnapshot(): boolean {
  return isPhoneViewport({
    coarse: window.matchMedia(COARSE_POINTER).matches,
    w: window.innerWidth,
    h: window.innerHeight,
    override: PHONE_OVERRIDE,
  });
}

function getServerSnapshot(): boolean {
  return false;
}

/** Coarse pointer AND shorter viewport side <= 550px (see domain/device.ts
 * for why not user-agent or width). Distinct from `useIsMobile` (a plain
 * width breakpoint that a narrowed desktop window also matches): this one
 * decides what a phone can USE -- which tabs exist, table vs cards -- while
 * the Tailwind breakpoints keep deciding how things are laid out. */
export function useIsPhone(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
